import { Component, OnInit, Input,  Output, EventEmitter,  } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../services/data.service';
import { APIService } from '../../api.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-enter-expense',
  templateUrl: './enter-expense.component.html',
  styleUrls: ['./enter-expense.component.scss']
})
export class EnterExpenseComponent implements OnInit{
  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private apiService: APIService,
    public CmnService: CommonService,
    public dataSer: DataService,
  ) {}

  
  @Input() Data: any;
  @Input() mdlRef: any;
  @Input() mdlRef2: any;	
  @Input() prTypeID: number = 1;
  @Input() isFromCostTypeList:  boolean = false;
  @Input() isFromCostTypeEntry: boolean = false;
  @Input() jobDetails: any;
 
  jarvisData: any = [];
  MTbl: any = [];
  isWeb: boolean = true;
  costTypeList: any = [];
  costType = {
    name: '',
    amount: 0,
    description: '',
    UID: 0
  }
  costTypeData: any = [];
  allcostTypesList: any = [];
  userList:any = [];
  AllData: any = [];
  isAdd: boolean = false;
  isDelete: boolean = false;
  costSum: number = 0;
  modalReference: any;

  ngOnInit(): void {
    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    this.isWeb = this.apiService.apiCheckWeb();

    var tblM = this.apiService.getCookie('M');
    if (tblM) {
      this.MTbl = JSON.parse(tblM);
   }
   var userList = this.apiService.getCookie("J");
   if(userList){
      let tempUserList = JSON.parse(userList);
      if(tempUserList.length > 0){
        this.userList = tempUserList;
      }
   }
   
  // this.getCostTypes();
  this.getJobDetails();
  this.getExpense();
  }

  getCostTypes(){
    if(this.jobDetails[0].Costs){
      let tempAllCostTypes = JSON.parse(this.jobDetails[0].Costs)
      if(tempAllCostTypes.length > 0){
        let tempAllCostList = tempAllCostTypes.filter((x: any) => x.IsD == false)
        if(tempAllCostList.length > 0)
        {
          this.allcostTypesList = tempAllCostList;
        }
        this.allcostTypesList.forEach((b: any) => {	
        let ownUserID: number = this.jarvisData[0].UserID;
        let tempUserList = $.grep(this.userList, function(o: any){ return o.UserID == ownUserID })[0];
        if(tempUserList)
        {
          b.userName = tempUserList.Name
        }
        });
      }
    }
  }

  // get costtypes from coockie
  getExpense(){
    var erpCfgData = this.apiService.getCookie("ERP_Cfg");
    if (erpCfgData) {
    let tempCfg = JSON.parse(erpCfgData);
    if(tempCfg.length > 0){
      if(tempCfg[0].CostTypes){
        let tempcostTypeList = JSON.parse(tempCfg[0].CostTypes);
        if(tempcostTypeList.length > 0)
        {
          this.costTypeList = tempcostTypeList.filter((x: any) => x.IsD == false)
          this.costTypeList = this.costTypeList.sort((a: any, b: any) => a.CNm.localeCompare(b.CNm));
        }
        // if (this.costTypeList.length == 0) {
        //   this.apiService.successAlert("Please Configure Expense Type from Settings > Expense Types.");	
        //   this.closeCostTypeMdl();	
        //   return;
        // }
      }
    }
  
  }}


  // close CostTypeEntryModal() - cost type entry modal close
  closeCostTypeMdl() {
    let doneObj = {
      action: 'Done',
    };
    this.mdlRef.close(doneObj);
  }

  //Expense Amount
  enterExpenseAmount = () => {
    this.costType.amount = this.CmnService.PrecisionwiseValue(this.costType.amount, 2)
  }

 //fn_addCostType() - add new expense
  fn_addCostType(obj: string){
    debugger
      if((this.costType.name).trim() == ''){	
        this.apiService.successAlert("Please select an Expense Type.");	
        return;	
      }	
      if((this.costType.amount) == 0) {
        this.apiService.successAlert("Please enter a valid Expense amount.");
        return;
      }
      let tmpCost = this.costTypeList.filter((x: any) => x.CNm == this.costType.name)
      if(tmpCost.length > 0){
        this.costType.name = tmpCost[0].CNm
      }
      else{
        this.apiService.successAlert("Please select a valid Expense Type.");
        return;	
      }
      let maxSr: any = 0;	
    let ids: any = [];

    // if (this.allcostTypesList.length > 0) {	
    //   ids = this.allcostTypesList.map((object: { CID: any; }) => {	
    //     return object.CID;
    //   })
    // }
    // this.costTypeData = []; 
    // maxSr = Math.max(...ids);	

    this.costTypeData.push({
      CID: 0,  //Number(maxSr) + 1,	//1, // Number(maxSr) + 1,	
      CNm: this.costType.name,	
      Amt: this.costType.amount,	
      D: this.costType.description,	
      UID: this.jarvisData[0].UserID,
      DT: new Date().customFormat("#DD#-#MMM#-#YY#") //new Date(),
    });
    
    this.fn_saveCostTypeEntry()

  }

  // fn_deleteExpenseType() - delete type
  fn_deleteExpenseType(e:any){
    if(confirm("Are you sure you want to delete this expense?")){
      this.isDelete = true;
      // this.expenseData = [{
      //   CID: e.CID,
      //   CNm: e.CNm,
      // }]
      this.costTypeData.push({
        CID: e.CID,	//1, // Number(maxSr) + 1,	
        CNm: e.CNm,	
        Amt: e.Amt,	
        D:  e.D,	
        UID: e.UID,
        DT: e.DT,
      });
      this.fn_saveCostTypeEntry()
    }
  }

  // fn_saveCostTypeEntry() - save costtype  modal 	
  fn_saveCostTypeEntry() {
    let generationList: any = [];
    let ConsumptionList: any = [];
    if(this.jobDetails.length > 0){
      if(this.jobDetails[0].Generation){
        let tempGenList = JSON.parse(this.jobDetails[0].Generation)
        for (let i = 0; i < tempGenList.length; i++) {
          let obj = {
            ItemID: tempGenList[i].PID,
            PlanQty: tempGenList[i].PQty + '',
            DoneQty: tempGenList[i].GenQty + '',
            XnIDs: '',
            Description: tempGenList[i].D ? tempGenList[i].D : '',
          };
          generationList.push(obj);
        }
      }

      if(this.jobDetails[0].Consumption){
        let tmpConsumptionList = JSON.parse(this.jobDetails[0].Consumption)
        for (let i = 0; i < tmpConsumptionList.length; i++) {
          let obj = {
            ItemID: tmpConsumptionList[i].MID,
            PlanQty: tmpConsumptionList[i].PQty + '',
            DoneQty: tmpConsumptionList[i].UsedQty + '',
            XnIDs: '',
            Description: tmpConsumptionList[i].D ? tmpConsumptionList[i].D : '',
          };
          ConsumptionList.push(obj);
        }
      }
    }
    

    let MyLastSyncDT = localStorage.getItem('MyLastSyncDT');

    var tempData = [
      {
        JobID: this.jobDetails[0].JobID,
        TargetDT: this.jobDetails[0].TargetDT,
        Stages: this.jobDetails[0].Stages,
        Generation: JSON.stringify(generationList),
        Consumption: JSON.stringify(ConsumptionList),
        ChangeType: this.isDelete ? 'PROJCOSTDEL' : 'PROJCOSTADD',
        Costs: JSON.stringify(this.costTypeData),
      },
    ];
    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: MyLastSyncDT,
        isWeb: true,
        ForERPAgencyID: this.MTbl[0].ERPAgencyID,
        actionType: 'setDetail',
        moduleID: 7,
        data: JSON.stringify(tempData),
      },
    ];

    // return;
    this.apiService.sendChange(myParams,this.suucessCostTypeEntry.bind(this), this.failureRespSave.bind(this)
    );
  }

  //suucessCostTypeEntry - success voucher entry handler
  suucessCostTypeEntry(res: any) {
    if (res.error) {
    } else {
      this.getJobDetails();
      this.closeCostTypeMdl();
    }
  }

  //failureResp - failure handler
  failureRespSave(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
  }
  
  getJobDetails() {
    let obj = [
      {
        JobID: this.jobDetails[0].JobID,
      },
    ];

    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.MTbl[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getPrdJobDetails',
        moduleID: 8,
        data: JSON.stringify(obj),
      },
    ];

    this.apiService.getData(
      myParams,
      this.successJobDetails.bind(this),
      this.failureResp.bind(this)
    );
  }

  successJobDetails(res: any) {
    if (res.error) {
    } else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        this.AllData = reponseData;
        if (reponseData) {
          this.jobDetails = reponseData.Table1;
          if(this.jobDetails[0].Costs)
          {
            let tempCost = JSON.parse(this.jobDetails[0].Costs);
            if(tempCost.length > 0){
              this.allcostTypesList = [];
              // this.allcostTypesList = tempCost;
              let tempAllCostList = tempCost.filter((x: any) => x.IsD == false)
              if (tempAllCostList.length > 0) {
                this.allcostTypesList = tempAllCostList;
              }
              
              this.allcostTypesList.forEach((b: any) => {
                // Get the UID from the current item in allcostTypesList
                let costItemUID = b.UID;
                
                // Find the matching user in userList where UserID equals the UID
                let matchingUser = $.grep(this.userList, function(o: any) { 
                  return o.UserID == costItemUID;
                })[0];
                
                // If a matching user is found, set the userName
                if (matchingUser) {
                  b.userName = matchingUser.Name; // Or matchingUser.Name depending on your requirements
                } else {
                  // Optional: handle case where no matching user is found
                  b.userName = "-";
                }
              });
              // let costSum = 0;
              this.costSum = this.allcostTypesList.reduce((accumulator:any, object:any) => {
                return accumulator + object.Amt;
              }, 0);
              let sendData = {'prTypeID': this.prTypeID, 'costSum' : this.costSum, 'jobID': this.jobDetails[0].JobID}
              this.dataSer.updateProjectData(sendData)
            }
            //this.getCostTypes();
          }
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

  openExpenseEntry(): void {
    if (this.costTypeList.length === 0) {
      this.apiService.successAlert("Please Configure Expense Type from Settings > Expense Types.");
      return;
    }

    this.modalReference = this.modalService.open(EnterExpenseComponent, {
      windowClass: 'costTypeEntryMdl',
      backdrop: 'static',
      keyboard: false
    });

    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.isFromCostTypeEntry = true;
    this.modalReference.componentInstance.jobDetails = this.jobDetails;

    // Handle modal close/dismiss
    this.modalReference.result.then(
      () => this.refreshData(),
      () => {}
    );
  }

  private refreshData(): void {
    this.getJobDetails();
    this.getExpense();
  }

}
